import { render, staticRenderFns } from "./AlteracaoSegmentation.vue?vue&type=template&id=4f710f92&scoped=true"
import script from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
export * from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoSegmentation.vue?vue&type=style&index=0&id=4f710f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f710f92",
  null
  
)

export default component.exports